import React, { Component } from 'react';
import { find, get, pick } from 'lodash';
import SelectField from '../../forms/SelectField';
import { THEME_WHITE } from '../../../constants/styling/themes';
import { MODELS } from '../../../constants/admin/settings';
import PerformancesModal from './PerformancesModal';
import DatepickerUnlimited from '../../forms/DatepickerUnlimited';
import { requireUseUntil } from '../../../selectors/admin/models/lineup';
import Button from '../../forms/Button';
import { UserContext } from '../../../Application';
import { PERMISSIONS, hasPermissions } from '../../../constants/authentication/permissions';
import { CLEARING_OPTIONS } from '../../../constants/settings';

class PerformancesStates extends Component {
    state = {
        editModalOpen: false
    };
    _getPartnerName = clearing => {
        const partners = this.props.dependencies.partners || [];
        return (
            get(
                find(partners, p => p.id === clearing.partnerId),
                'name'
            ) || ''
        );
    };
    _closeModal = () => {
        this.setState({ editModalOpen: false });
    };
    _saveModal = (partnerId, data) => {
        const newClearing = [...(this.props.clearing || [])].map(c => {
            if (c.partnerId === partnerId || data.copyFor.includes(c.partnerId)) {
                return { ...pick(data, ['live', 'nonLinear', 'useUntil', 'comments']), partnerId: c.partnerId };
            } else {
                return c;
            }
        });
        this.props.setClearing(newClearing, `${MODELS.ENTRY}.clearing`);
        this.setState({ editModalOpen: false });
    };
    _openModal = (e, partner) => {
        if ((e.target.className || '').includes('ckp-admin-table-dark-column')) {
            this.setState({ editModalOpen: partner });
        }
    };
    _setNonLinear = (value, name) => {
        this.props.setClearing(0, name.replace('nonLinear', 'useUntil'));
        this.props.setClearing(value, name);
    };
    render() {
        return (
            <div>
                <header className="ckp-admin-performances-form-title">
                    <h4 className="ckp-ts-h1">Clearance</h4>
                    <UserContext.Consumer>
                        {user => (
                            <div className="ckp-admin-performances-form-contracts">
                                {hasPermissions(user, PERMISSIONS.CONTRACT_ADD) && this.props.performanceId ? (
                                    <Button
                                        onClick={this.props.openContractModal}
                                        label={'Create Clearance contract'}
                                    />
                                ) : null}
                                {hasPermissions(user, PERMISSIONS.CONTRACTS_VIEW) && this.props.contractToLoad ? (
                                    <Button
                                        onClick={this.props.loadContractInfo}
                                        label={'Import from contract'}
                                        inactive={!this.props.contractToLoad}
                                        loading={this.props.fetchingContracts}
                                    />
                                ) : null}
                            </div>
                        )}
                    </UserContext.Consumer>
                </header>
                <PerformancesModal
                    getPartnerName={this._getPartnerName}
                    open={this.state.editModalOpen}
                    closeModal={this._closeModal}
                    saveModal={this._saveModal}
                    onInput={this.props.setClearing}
                    dependencies={this.props.dependencies}
                    clearing={this.props.clearing}
                />
                <div className="ckp-admin-table-dark" style={{ width: '1200px' }}>
                    <ul className="ckp-admin-table-dark-header">
                        <li className="ckp-admin-table-dark-header-title">Mediapartner</li>
                        <li className="ckp-admin-table-dark-header-title">Cleared Live</li>
                        <li className="ckp-admin-table-dark-header-title">Cleared Non Linear</li>
                        <li className="ckp-admin-table-dark-header-title">Non Linear Use Until</li>
                        <li className="ckp-admin-table-dark-header-title">Comments</li>
                    </ul>
                    <div className="ckp-admin-table-dark-body">
                        {(this.props.clearing || []).map((partnerClearing, i) => {
                            return (
                                <ul
                                    onClick={e => this._openModal(e, partnerClearing)}
                                    key={partnerClearing.partnerId}
                                    className="ckp-admin-table-dark-row"
                                >
                                    <li className="ckp-admin-table-dark-column u-truncate">
                                        {this._getPartnerName(partnerClearing)}
                                    </li>
                                    <li className="ckp-admin-table-dark-column u-truncate">
                                        <SelectField
                                            onChange={this.props.setClearing}
                                            name={`${MODELS.ENTRY}.clearing.${i}.live`}
                                            items={CLEARING_OPTIONS}
                                            theme={THEME_WHITE}
                                            value={partnerClearing.live}
                                        />
                                    </li>
                                    <li className="ckp-admin-table-dark-column u-truncate">
                                        <SelectField
                                            onChange={this._setNonLinear}
                                            name={`${MODELS.ENTRY}.clearing.${i}.nonLinear`}
                                            items={CLEARING_OPTIONS}
                                            theme={THEME_WHITE}
                                            value={partnerClearing.nonLinear}
                                        />
                                    </li>
                                    <li className="ckp-admin-table-dark-column u-truncate">
                                        {requireUseUntil(partnerClearing.nonLinear) ? (
                                            <DatepickerUnlimited
                                                name={`${MODELS.ENTRY}.clearing.${i}.useUntil`}
                                                onChange={this.props.setClearing}
                                                theme={THEME_WHITE}
                                                value={partnerClearing.useUntil}
                                            />
                                        ) : null}
                                    </li>
                                    <li className="ckp-admin-table-dark-column u-truncate">
                                        {partnerClearing.comments}
                                    </li>
                                </ul>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default PerformancesStates;



// WEBPACK FOOTER //
// ./src/components/admin/lineup/PerformancesStates.js